import { Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

import TrackButton from 'artkive/components/Tracker/TrackButton'

// NOTE: this mostly copies the BrandsBannerWrap
export const Wrapper = styled('div')(({ theme, bgColor }) => ({
  position: 'relative',
  backgroundColor: bgColor || theme.colors.black,
  height: `${theme.constants.brandBanner.mobileHeight}px`,
  display: 'grid',
  gridTemplateColumns: '0 1fr 0',
  alignItems: 'center',
  zIndex: 1200,
  padding: '0 16px',
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '160px 1fr 160px',
    height: `${theme.constants.brandBanner.height}px`,
  },
  [theme.breakpoints.up('lg')]: {
    padding: '0 50px',
  },
}))

export const SaleText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.75rem',
  },
}))

export const SaleBannerButton = styled(TrackButton)(({ theme, textColor }) => ({
  color: textColor || theme.colors.white,
  textTransform: 'none',
  minWidth: 'auto',
  padding: 0,
  margin: theme.spacing(0, 0.5),
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: 'transparent',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.75rem',
  },
}))
